// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2nILK","bigColWidth":"Table_bigColWidth__2wMOf","biggerColWidth":"Table_biggerColWidth__32PnT","row":"Table_row__2amuL","col":"Table_col__g_rsS"};